export class ArbetsorderProduktvalProduktionsmallTexts {
// eslint-disable-next-line sonarjs/public-static-readonly
    static validation = {
        missingMallnamn: "Mallnamn får inte vara tomt",
        maxLengthError: "För många tecken har angivits",
        missingHandelssortiment: "Handelssortiment får inte vara tomt"
    };
    // eslint-disable-next-line sonarjs/public-static-readonly
    static texts = {
        mallNamn: "Namn",
        skapaprodmall: "Ny produktionsmall"
    };
}
